enum NotificationRuleConditionOperator {
	Equals = 0,
    Contains = 1,
    LessThan = 2,
    GreaterThan = 3,
    InheritsFrom = 4
}

export default NotificationRuleConditionOperator;